import { ConfirmDialog } from '@/components/blocks/ConfirmDialog/ConfirmDialog';
import { WALLET_PHRASES } from '@/consts/phrases/walletPhrases';
import { usePhrase } from '@/hooks';
import { AmazonGiftCard } from './AmazonGiftCard/AmazonGiftCard';
import { IAccount } from '@/types';

interface AmazonGiftCardModalProps {
    handleClose: () => void;
    isOpen: boolean;
    transactionId?: number;
    transactionMethodId?: number;
    selectedAccount: IAccount;
}

export const AmazonGiftCardModal = (props: AmazonGiftCardModalProps) => {
    const { t } = usePhrase();

    return (
        <ConfirmDialog
            title={t(WALLET_PHRASES.AMAZON_GIFT_CARD)}
            open={props.isOpen}
            handleClose={props.handleClose}
            data-testid="amazonGiftCardModal"
            maxWidth="sm"
        >
            {props.transactionId && props.transactionMethodId && (
                <AmazonGiftCard
                    transactionId={props.transactionId}
                    transactionMethodId={props.transactionMethodId}
                    currencyCode={props.selectedAccount.currencyCode}
                    currencySymbol={props.selectedAccount.currencySymbol}
                    currencySymbolPosition={props.selectedAccount.currencySymbolPosition}
                />
            )}
        </ConfirmDialog>
    );
};
